import { useAblyTypedPubSub } from '../use-ably'

export const usePollPubSub = ({ onPollUpdate }: { onPollUpdate: (results: any) => void }) => {
  const { publish } = useAblyTypedPubSub<any>('poll', ({ data }) => {
    onPollUpdate(data)
  })

  const broadCastVote = (pollingResults: any) => {
    publish(pollingResults)
  }

  return { broadCastVote }
}
